/* tslint:disable */
/* eslint-disable */
/**
 * Vercasa API
 * Vercasa API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A list of properties with a name created by the user
 * @export
 * @interface PropertyList
 */
export interface PropertyList {
    /**
     * 
     * @type {string}
     * @memberof PropertyList
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyList
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PropertyList
     */
    propertyCount: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyList
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PropertyList
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the PropertyList interface.
 */
export function instanceOfPropertyList(value: object): value is PropertyList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('propertyCount' in value) || value['propertyCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PropertyListFromJSON(json: any): PropertyList {
    return PropertyListFromJSONTyped(json, false);
}

export function PropertyListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'propertyCount': json['property_count'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function PropertyListToJSON(json: any): PropertyList {
    return PropertyListToJSONTyped(json, false);
}

export function PropertyListToJSONTyped(value?: PropertyList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'property_count': value['propertyCount'],
        'created_at': ((value['createdAt']).toISOString()),
        'updated_at': ((value['updatedAt']).toISOString()),
    };
}

